exports.softwareReleaseMajor = 6;
exports.softwareReleaseMinor = 2;
exports.softwareReleaseQFE = 0;
exports.softwareReleaseBuildId = '864';
